// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__AZK6U","verticalLine":"Sidebar_verticalLine__xg9df","socialIcons":"Sidebar_socialIcons__TcQCh","icons":"Sidebar_icons__dyXjA"};